import { useMemo } from 'react';
import {
  calculatePickerGroupsTotals,
  calculatePickerTotals,
  calculateBlockTotals,
  calculateAgroActionsTotals,
  calculatePackerGroupsTotals,
  calculatePackerTotals,
  calculatePickingTotals,
  calculatePackingTotals,
  calculateAgroGroupsTotals
} from '../utils/tableUtils';
import {
  pickerGroupsColumns,
  pickerMonitorColumns,
  blockMonitorColumns,
  agroActionsColumns,
  packerGroupsColumns,
  packerMonitorColumns,
  pickingColumns,
  pickingColumnsWithDate,
  packingColumns,
  packingColumnsWithDate,
  agroGroupsMonitoringColumns
} from '../config/tableConfigs';

export const useTableData = (data, type) => {
  return useMemo(() => {
    let columns, totalsRow;

    switch (type) {
      case 'pickerGroups':
        columns = pickerGroupsColumns;
        totalsRow = calculatePickerGroupsTotals(data);
        break;
      case 'pickerMonitor':
        columns = pickerMonitorColumns;
        totalsRow = calculatePickerTotals(data);
        break;
      case 'blockMonitor':
        columns = blockMonitorColumns;
        totalsRow = calculateBlockTotals(data);
        break;
      case 'agroActions':
        columns = agroActionsColumns;
        totalsRow = calculateAgroActionsTotals(data);
        break;
      case 'agroGroups':
        columns = agroGroupsMonitoringColumns;
        totalsRow = calculateAgroGroupsTotals(data);
        break;
      case 'packerGroups':
        columns = packerGroupsColumns;
        totalsRow = calculatePackerGroupsTotals(data);
        break;
      case 'packerMonitor':
        columns = packerMonitorColumns;
        totalsRow = calculatePackerTotals(data);
        break;
      case 'picking': {
        // Use columns with date if data includes date field
        const hasDateField =
          data.length > 0 && Object.prototype.hasOwnProperty.call(data[0], 'date');
        columns = hasDateField ? pickingColumnsWithDate : pickingColumns;
        totalsRow = calculatePickingTotals(data);
        break;
      }
      case 'packing': {
        // Use columns with date if data includes date field
        const hasPackingDateField =
          data.length > 0 && Object.prototype.hasOwnProperty.call(data[0], 'date');
        columns = hasPackingDateField ? packingColumnsWithDate : packingColumns;
        totalsRow = calculatePackingTotals(data);
        break;
      }
      default:
        columns = [];
        totalsRow = null;
    }

    return {
      columns,
      rows: totalsRow ? [...data, totalsRow] : data
    };
  }, [data, type]);
};
